var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/04 Menu/Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/04-Menu/Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1828765,
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.4,
    fill: "#B4E1B3",
    x: 0.8,
    y: 10.4,
    width: 8,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.4,
    fill: "#B4E1B3",
    x: 13.6,
    y: 0.8,
    width: 8,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07262919,7.2 L1.52721097,7.2 C0.68506368,7.2 0,6.49352955 0,5.62490213 L0,1.57493304 C0,0.70647045 0.68506368,0 1.52721097,0 L8.07262919,0 C8.91493632,0 9.6,0.70647045 9.6,1.57493304 L9.6,5.62490213 C9.6,6.49352955 8.91493632,7.2 8.07262919,7.2 Z M1.52721097,1.3499897 C1.4068814,1.3499897 1.30908364,1.45084342 1.30908364,1.57493304 L1.30908364,5.62490213 C1.30908364,5.74915658 1.4068814,5.8500103 1.52721097,5.8500103 L8.07262919,5.8500103 C8.1931186,5.8500103 8.29091636,5.74915658 8.29091636,5.62490213 L8.29091636,1.57493304 C8.29091636,1.45084342 8.1931186,1.3499897 8.07262919,1.3499897 L1.52721097,1.3499897 Z",
    id: "Shape",
    fill: "#1E2740",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07262919,22.4 L1.52721097,22.4 C0.68506368,22.4 0,21.6823134 0,20.8000628 L0,11.2001047 C0,10.3176866 0.68506368,9.6 1.52721097,9.6 L8.07262919,9.6 C8.91493632,9.6 9.6,10.3176866 9.6,11.2001047 L9.6,20.8000628 C9.6,21.6823134 8.91493632,22.4 8.07262919,22.4 Z M1.52721097,10.9714226 C1.4068814,10.9714226 1.30908364,11.0738775 1.30908364,11.2001047 L1.30908364,20.8000628 C1.30908364,20.9261225 1.4068814,21.0285774 1.52721097,21.0285774 L8.07262919,21.0285774 C8.1931186,21.0285774 8.29091636,20.9261225 8.29091636,20.8000628 L8.29091636,11.2001047 C8.29091636,11.0738775 8.1931186,10.9714226 8.07262919,10.9714226 L1.52721097,10.9714226 Z",
    id: "Shape",
    fill: "#1E2740",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.872789,22.4 L14.3273708,22.4 C13.4850637,22.4 12.8,21.6935296 12.8,20.825067 L12.8,16.7750979 C12.8,15.9064704 13.4850637,15.2 14.3273708,15.2 L20.872789,15.2 C21.7149363,15.2 22.4,15.9064704 22.4,16.7750979 L22.4,20.825067 C22.4,21.6935296 21.7149363,22.4 20.872789,22.4 L20.872789,22.4 Z M14.3273708,16.5499897 C14.2068814,16.5499897 14.1090836,16.6508434 14.1090836,16.7750979 L14.1090836,20.825067 C14.1090836,20.9491566 14.2068814,21.0500103 14.3273708,21.0500103 L20.872789,21.0500103 C20.9931186,21.0500103 21.0909164,20.9491566 21.0909164,20.825067 L21.0909164,16.7750979 C21.0909164,16.6508434 20.9931186,16.5499897 20.872789,16.5499897 L14.3273708,16.5499897 Z",
    id: "Shape",
    fill: "#1E2740",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.872789,12.8 L14.3273708,12.8 C13.4850637,12.8 12.8,12.0823134 12.8,11.1998953 L12.8,1.59993721 C12.8,0.717686613 13.4850637,0 14.3273708,0 L20.872789,0 C21.7149363,0 22.4,0.717686613 22.4,1.59993721 L22.4,11.1998953 C22.4,12.0823134 21.7149363,12.8 20.872789,12.8 L20.872789,12.8 Z M14.3273708,1.37142259 C14.2068814,1.37142259 14.1090836,1.4738775 14.1090836,1.59993721 L14.1090836,11.1998953 C14.1090836,11.3261225 14.2068814,11.4285774 14.3273708,11.4285774 L20.872789,11.4285774 C20.9931186,11.4285774 21.0909164,11.3261225 21.0909164,11.1998953 L21.0909164,1.59993721 C21.0909164,1.4738775 20.9931186,1.37142259 20.872789,1.37142259 L14.3273708,1.37142259 Z",
    id: "Shape",
    fill: "#1E2740",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#373A37",
    strokeWidth: 1.6,
    x: 0.8,
    y: 0.8,
    width: 8,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#373A37",
    strokeWidth: 1.6,
    x: 13.6,
    y: 16,
    width: 8,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#373A37",
    strokeWidth: 1.6,
    x: 13.6,
    y: 0.8,
    width: 8,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#373A37",
    strokeWidth: 1.6,
    x: 0.8,
    y: 10.4,
    width: 8,
    height: 11.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.dae3ba0f07434e48ef50d7e9f7093ba8.svg";
export { ForwardRef as ReactComponent };